import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import HeaderNavbar from "../Component/Navbar";
import Footer from "../Component/Footer";

export default function PlatformUsage() {
  return (
    <>
      <HeaderNavbar />

      {/* PAGE HEADER */}
      <div
        style={{
          background: "#f8f5f2",
          padding: "60px 0",
          textAlign: "center",
        }}
      >
        <h1 style={{ color: "#7b1e3b", fontWeight: "600" }}>Community Standards, Safety & Platform Usage Policy</h1>


      </div>

      {/* TERMS SECTION */}
      <Container style={{ padding: "70px 10px" }}>
        <Row>
          <Col lg={12}>
            <h3 className="mb-3">1. Purpose</h3>
            <p>
              KVL Matrimony is committed to providing a respectful, safe and trustworthy Platform (https://kvlmatrimony.com) for matrimonial connections within the Veerashaiva Lingayat community.<br />
              This Policy outlines the expected standards of conduct for all members.


            </p>
            <h3 className="mt-5 mb-3">2. Community Standards</h3>
            <p>Members are expected to:<br />
              •	Maintain honesty and integrity.<br />
              •	Treat other members with dignity and respect.<br />
              •	Use the Platform only for genuine matrimonial purposes.<br />
              •	Respect the privacy and preferences of other members.<br />
              •	Comply with applicable laws and Platform policies.<br />
            </p>
            <h3 className="mt-5 mb-3">3. Safe Usage</h3>
            <p>Members are encouraged to:<br />
              •	Verify information independently before making personal decisions.<br />
              •	Exercise caution while sharing personal or financial information.<br />
              •	Meet in safe public places for initial interactions.<br />
              •	Inform family members or trusted persons before offline meetings.<br />
              •	Report suspicious behaviour immediately.

            </p>

            <h3 className="mt-5 mb-3">4. Unacceptable Conduct</h3>
            <p>
              The following activities are strictly prohibited:<br />
              •	Fake or misleading profiles.<br />
              •	Impersonation or identity misuse.<br />
              •	Harassment, abuse, threats or intimidation.<br />
              •	Obscene, offensive or unlawful content.<br />
              •	Financial solicitation or fraudulent activities.<br />
              •	Spam, unsolicited promotions or commercial use.<br />
              •	Misuse of another member's personal information.<br />
              •	Any activity that disrupts the integrity or security of the Platform.


            </p>

            <h3 className="mt-5 mb-3">5. Communication Standards</h3>
            <p>
              Members shall communicate courteously and responsibly.<br />
              Repeated unwanted communication, abusive language, discriminatory remarks or inappropriate behaviour may result in appropriate action by the Platform.
            </p>

            <h3 className="mt-5 mb-3">6. Fraud Prevention</h3>
            <p>
              KVL Matrimony encourages members to promptly report:<br />
              •	Fake profiles<br />
              •	Identity fraud<br />
              •	Financial scams<br />
              •	Misuse of photographs<br />
              •	Blackmail or extortion<br />
              •	Suspicious communications<br />
              The Platform may review reported incidents and take appropriate action where necessary.


            </p>

            <h3 className="mt-5 mb-3">7. Content Moderation</h3>
            <p>
              KVL Matrimony reserves the right to review, restrict or remove content that violates Platform policies or applicable laws.<br />
              Appropriate action may include warning, temporary suspension or permanent removal of user access.


            </p>

            <h3 className="mt-5 mb-3">8. Platform Responsibility</h3>
            <p>KVL Matrimony provides a technology platform to facilitate matrimonial introductions.<br />
              Members are solely responsible for their communications, interactions and decisions made on or outside the Platform.<br />
              Users are advised to exercise independent judgment and due diligence before establishing any personal relationship.


            </p>
            <h3 className="mt-5 mb-3">9. Reporting Concerns</h3>
            <p>
              Members may report policy violations, suspicious activity or safety concerns through the Platform's designated support or grievance channels.<br />
              All reports shall be reviewed in a fair and confidential manner.

            </p>

            <h3 className="mt-5 mb-3">10. Policy Updates</h3>
            <p>
              This Policy may be updated periodically to enhance user safety, improve community standards or comply with applicable legal requirements.<br />
              The latest version shall always be available on the Platform https://kvlmatrimony.com.

            </p>

            <h3 className="mt-5 mb-3">11. User Declaration</h3>
            <p>
              By using KVL Matrimony, you acknowledge that you have read and understood this Policy and agree to maintain a safe, respectful and responsible environment for all members.
            </p>



            <p className="mt-5 text-muted">
              <strong>Last Updated:</strong>5th, July 2026
            </p>
          </Col>
        </Row>
      </Container>





      <Footer />
    </>
  );
}
